import { motion } from "framer-motion";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { getWhatsAppLink } from "@/lib/site";
import { useLanguage } from "@/lib/i18n";

export default function WhatsAppBeacon() {
  const { t } = useLanguage();

  return (
    <motion.a
      data-testid="whatsapp-float-cta"
      href={getWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsappAria}
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.8, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.08, rotate: 4 }}
      whileTap={{ scale: 0.94 }}
      className="fixed right-5 bottom-5 z-[60] grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/35 sm:right-7 sm:bottom-7"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/40" aria-hidden="true" />
      <WhatsAppIcon size={26} className="relative" />
    </motion.a>
  );
}
